import st from './Agent.module.scss'
import noPhoto from 'assets/images/no-photo.jpg'

const nameFormat = (str)=> {
    const name = str.split(' ')[0]+' <br/>' +str.split(' ').slice(1).join(' ')
    return name
}

const alterSrc = img => !img ? noPhoto : img
export const Item = ({ data })=> {
    const errorImg = (e) => {
        e.currentTarget.onerror = null
        e.currentTarget.src = noPhoto
    }

    return (
        <div className={st.item}>
            <div className={st.ava}>
                <picture>
                    <img src={alterSrc(data.photo)} onError={errorImg} alt="" width={200} height={200} />
                </picture>
            </div>

            <h3 className={st.name}><span dangerouslySetInnerHTML={{__html: nameFormat(data.name) }} /></h3>
            <p className={st.desc}>{data.position_site}</p>
        </div>
    )
}
